import React from 'react';
import { Modal, Button, Message } from 'semantic-ui-react';

const DeleteConfirmationModal = ({ 
    open, 
    onClose, 
    onConfirm, 
    isDeleting = false,
    requestData = null 
}) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            size="small"
            closeOnDimmerClick={!isDeleting}
            closeOnEscape={!isDeleting}
        >
            <Modal.Header>
                Delete Request
                {requestData && (
                    <div style={{ fontSize: '0.8em', fontWeight: 'normal', marginTop: '4px', color: '#666' }}>
                        Request ID: {requestData.id}
                    </div>
                )}
            </Modal.Header>
            
            <Modal.Content>
                <Message warning>
                    <Message.Header>Are you sure you want to delete this request?</Message.Header>
                    <p>This action cannot be undone. The request will be permanently deleted from the system.</p>
                </Message>
            </Modal.Content>

            <Modal.Actions>
                <Button 
                    onClick={onClose}
                    disabled={isDeleting}
                >
                    Cancel
                </Button>
                <Button 
                    negative
                    loading={isDeleting}
                    disabled={isDeleting}
                    onClick={onConfirm}
                >
                    Delete Request
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default DeleteConfirmationModal;

